import { IonRow, IonCol, IonButton, useIonAlert } from '@ionic/react'

import { useAccount, useAuth } from '../../../contexts/authContext'
import { useToast } from '../../../contexts/toastContext'
import { useCreateOptIn } from '../../../hooks/opt-in'

import type { PhoneNumber } from '../../../hooks/clients/queries'

type Props = {
  clientId: string
  defaultPhoneNumber: PhoneNumber | null
}

function OptInClientCard({ clientId, defaultPhoneNumber }: Props) {
  const [present] = useIonAlert()
  const setToast = useToast()
  const account = useAccount()
  const auth = useAuth()
  const createOptIn = useCreateOptIn()

  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size="auto">
        <IonButton
          color="yellow"
          disabled={createOptIn.isLoading}
          onClick={async () => {
            if (account.termsRequired) {
              present({
                message:
                  'You are about to automatically opt-in a client. By clicking "Accept" you acknowledge that you have their written permission to do so.',
                buttons: [
                  'Cancel',
                  {
                    text: 'Accept',
                    handler: async () => {
                      if (!defaultPhoneNumber) {
                        return setToast({
                          message:
                            'This client does not have a valid phone number to opt-in.',
                        })
                      }
                      await auth.acceptOptInClientTerms()
                      createOptIn.mutate(
                        {
                          defaultPhoneNumber,
                          client: {
                            objectId: clientId,
                          },
                          manualAccept: true,
                        },
                        {
                          onSuccess: () => {
                            setToast({
                              message: `This client was successfully opted-in.`,
                              color: 'yellow',
                            })
                          },
                        }
                      )
                    },
                  },
                ],
              })
            } else {
              if (!defaultPhoneNumber) {
                return setToast({
                  message:
                    'This client does not have a valid phone number to opt-in.',
                })
              }
              createOptIn.mutate({
                defaultPhoneNumber,
                client: {
                  objectId: clientId,
                },
                manualAccept: true,
              })
            }
          }}
        >
          Opt-In Client
        </IonButton>
      </IonCol>
    </IonRow>
  )
}

export { OptInClientCard }
